export const dataPatrimonio = state => state.activos.dataPatrimonio;
export const dataMes = state => state.activos.dataMes;
export const pending = state => state.fondoMutuo.pending;